import moment from 'moment';
class signature {
    constructor(
        Operador,
        Fecha

    ) {

        this.Operador = Operador
        this.Fecha = moment(Fecha).utc().format("DD-MM-YYYY")


    }
    static fromJson({
        Operador,
        Fecha

    }) {
        return new signature(
            Operador,
            Fecha

        );
    }
}
export default signature;
